import { confirmSignIn, resetPassword, signIn } from "aws-amplify/auth";

export async function resolveLoginUsername(login) {
  return String(login || "").trim();
}

export function signInWithPassword({ username, password }) {
  return signIn({ username, password });
}

export function confirmLoginChallenge({ challengeResponse, user }) {
  return confirmSignIn({
    challengeResponse,
    options: { user },
  });
}

export function startPasswordReset({ username }) {
  return resetPassword({ username });
}
